import { ComponentProps, FC } from 'react';
import { TbSitemap } from 'react-icons/tb';

type FundIconProps = ComponentProps<typeof TbSitemap>;

/** The canonical icon for Fund resources across the platform. */
const FundIcon: FC<FundIconProps> = ({ size = '1rem', ...props }) => (
    <TbSitemap {...props} data-resource-icon='fund' size={size} />
);

export default FundIcon;
